export default {
  tabs: {
    schedule: "Schedule",
    history: "History",
    logs: "Logs"
  },
  engineQueue: {
    loading: "Loading Engine queue...",
    loadError: "Could not load the Engine queue.",
    autoRefresh: "Auto-refresh every 5s",
    jobsTitle: "Workflow execution jobs",
    searchPlaceholder: "Search by agent, trigger, state or execution...",
    empty: "No jobs in the queue.",
    retry: "Retry",
    retried: "Job re-enqueued.",
    retryError: "Could not retry the job.",
    remove: "Remove",
    removed: "Job removed.",
    removeError: "Could not remove the job.",
    removeConfirm: "Remove this job from the queue? This action cannot be undone.",
    metrics: {
      waiting: "Waiting",
      active: "Active",
      delayed: "Delayed",
      failed: "Failed",
      completed: "Completed"
    },
    columns: {
      enqueuedAt: "Created",
      agent: "Agent",
      trigger: "Trigger",
      state: "State",
      attempts: "Attempts",
      actions: "Actions"
    }
  },
  schedule: {
    activeCalls: "Active Calls",
    upcomingMeetings: "Upcoming Meetings",
    withError: "With Error",
    activeCallsTitle: "Active Calls",
    upcomingMeetingsTitle: "Upcoming Meetings",
    calendarMeetingsTitle: "Calendar Meetings",
    mailboxHint: "Calendar Prodgy reads",
    statuses: {
      ready: "Ready",
      rejected: "Rejected"
    },
    filters: {
      status: "Status",
      workspace: "Workspace",
      allStatuses: "All statuses",
      allWorkspaces: "All workspaces"
    },

    searchPlaceholder: "Search by meeting, name, date...",
    noUpcomingMeetings: "No meetings in the coming days",
    rowsPerPage: "Rows per page",
    pagination: "{{current}} of {{total}}",
    series: "Series",
    seriesTooltip_one: "{{count}} occurrence of this series in the read window",
    seriesTooltip_other: "{{count}} occurrences of this series in the read window",
    untitledMeeting: "Untitled meeting",
    periods: {
      today: "Today",
      tomorrow: "Tomorrow",
      all: "Whole window"
    },
    a11y: {
      openMenu: "Open meeting menu",
      previousPage: "Previous page",
      nextPage: "Next page",
      rejectionReason: "Why this meeting was rejected",
    },
    syncNow: "Sync now",
    syncRequested: "Calendar read requested",
    actionError: "Action failed — please try again",
    reasons: {
      organizer_not_registered: "Organizer not registered",
      no_active_webhook: "No active agent",
      workspace_ambiguous: "Ambiguous workspace",
      no_teams_link: "No Teams link",
      blocked: "Blocked manually",
      not_recorded: "Could not be recorded",
      unknown: "Unknown reason"
    },
    reasonHelp: {
      organizer_not_registered: "Whoever organized the meeting is not registered in Prodgy.",
      no_active_webhook: "The organizer has no active agent to receive the transcription.",
      workspace_ambiguous: "The organizer has more than one workspace and none was given in the title.",
      no_teams_link: "The meeting has no Teams link for Prodgy to join.",
      blocked: "An administrator blocked this meeting on the panel.",
      not_recorded: "Prodgy could not record this meeting and stayed out, so it would not join it again later.",
      unknown: "The reason could not be determined."
    },
    columns: {
      created: "Created",
      from: "From",
      meeting: "Meeting",
      workspace: "Workspace",
      scheduled: "Scheduled",
      startTime: "Start",
      endTime: "End",
      reason: "Reason",
      status: "Status",
      time: "Time",
      actions: "Actions",
      callId: "Call ID"
    },
    actions: {
      details: "Details",
      blockMeeting: "Stop attending this meeting",
      blockSeries: "Stop attending the series",
      forceLeave: "Force Leave"
    },
    confirmBlockMeetingTitle: "Stop attending this meeting",
    confirmBlockMeetingDescription: "Prodgy will stop joining this meeting, even while it stays on the calendar.",
    confirmBlockSeriesTitle: "Stop attending the series",
    confirmBlockSeriesDescription: "Prodgy will stop joining every meeting of this series, even while they stay on the calendar.",
    confirmForceLeaveTitle: "Force Leave Call",
    confirmForceLeaveDescription: "Are you sure you want to force the bot to leave this active call? This action cannot be undone.",
    confirmCancelButton: "Cancel",
    confirmButton: "Confirm"
  },
  details: {
    meetingTitle: "Meeting Details",
    notAttendedTitle: "Why it will not be attended",
    callTitle: "Active Call Details",
    subject: "Subject",
    from: "From",
    workspace: "Destination workspace",
    scheduled: "Scheduled",
    scheduledTime: "Scheduled Time",
    startTime: "Start Time",
    meetingUrl: "Meeting Link",
    recurring: "Recurring",
    transcriptionLanguage: "Transcription language",
    maxWait: "Maximum wait",
    recurrenceDetail: "Recurrence pattern",
    recurrenceEndsAt: "Recurrence ends on",
    recurrencePatterns: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly"
    },
    minutes_one: "{{count}} minute",
    minutes_other: "{{count}} minutes",
    yes: "Yes",
    no: "No",
    callId: "Call ID"
  },
  history: {
    title: "Meeting History",
    today: "Today",
    last7Days: "7 days",
    last30Days: "30 days",
    last90Days: "90 days",
    loading: "Loading meeting history...",
    connectionError: "Error connecting to service. Please try again.",
    noMeetingEvents: "No meeting events found for this period",
    events: "events",
    segments: "segments",
    participants: "participants",
    duration: "Duration",
    meeting: "Meeting",
    downloadTranscript: "Download transcript",
    downloadTranscriptError: "Could not generate the download link.",
    eventTypes: {
      scheduled: "Scheduled",
      joined: "Joined",
      transcription: "Transcription Delivered",
      left: "Left",
      error: "Error"
    },
    status: {
      delivered: "Delivered",
      in_progress: "In Progress",
      error: "Error",
      completed: "Completed",
      scheduled: "Scheduled"
    }
  },
  logs: {
    title: "Logs",
    streaming: "Streaming",
    allLevels: "All Levels",
    info: "Info",
    warn: "Warn",
    error: "Error",
    start: "Start",
    stop: "Stop",
    clear: "Clear",
    terminalTitle: "Assistant Logs",
    lineCount: "{{count}} lines",
    noLogEntries: "No log entries to display",
    searchPlaceholder: "Search logs...",
    level: "Level",
    lines: "lines",
    connectionError: "Error connecting to the logs service. Please try again.",
    description: "View system logs in real-time"
  },
  config: {
    title: "Settings",
    loading: "Loading settings...",
    general: "General",
    baseUrl: "Base URL",
    assistantBaseUrl: "Assistant Base URL",
    apiConnection: "API Connection",
    engine: "Engine",
    apiBaseUrl: "Base URL",
    apiKey: "API Key",
    agentName: "Agent Name",
    calendarService: "Calendar Service",
    mailboxEnabled: "Enabled",
    mailbox: "Calendar Account (mailbox)",
    pollInterval: "Calendar Poll Interval (minutes)",
    horizonDays: "Read window (days)",
    maxWaitMinutes: "Max Wait Minutes",
    graphTenantId: "Graph Tenant ID",
    graphClientId: "Graph Client ID",
    graphClientSecret: "Graph Client Secret",
    logs: "Logs",
    logsApiKey: "API Key",
    logsDirectory: "Logs Directory",
    microsoftTeams: "Microsoft Teams",
    azureAd: "Azure AD",
    azureAdTenantId: "Tenant ID",
    azureAdClientId: "Client ID",
    azureAdClientSecret: "Client Secret",
    azureBot: "Azure Bot",
    botUserId: "Bot User ID",
    botName: "Bot Name",
    botBaseUrl: "Base URL",
    certThumbprint: "Certificate Thumbprint",
    save: "Save",
    saving: "Saving...",
    restartWarning: "Some changes may require a restart"
  }
} as const;